import * as React from 'react';
import Translate from '../../../common/functions/translate';

function getInteractionSeverity(type, value) {
  if (typeof type === 'string') {
    switch (type) {
      case 'icon':
        return getInteractionSeverityIcon(value);
      case 'iconAndText':
        return getInteractionSeverityIconAndText(value);
      case 'statusLabel':
        return getInteractionSeverityStatusLabel(value);
    }
  } else {
    return value;
  }
}

function getInteractionSeverityIcon(id: number) {
  if (id != undefined) {
    switch (id) {
      case 1:
        return <span className="pi pi-times-circle" style={{ color: '#d32f2f', paddingRight: "10px" }}></span>;
      case 2:
        return <span className="pi pi-exclamation-triangle" style={{ color: '#f57c00', paddingRight: "10px" }}></span>;
      case 3:
        return <span className="pi pi-exclamation-triangle" style={{ color: '#fbc02d', paddingRight: "10px" }}></span>;
      case 4:
        return <span className="pi pi-circle-on" style={{ color: '#b3b3b3', paddingRight: "10px" }}></span>;
      default:
        return null;
    }
  }
  return null;
}

function getInteractionSeverityIconAndText(id: number) {
  if (id != undefined) {
    switch (id) {
      case 1:
        return <>
          <span className="pi pi-times-circle" style={{ color: '#d32f2f', paddingRight: "10px" }}></span>
          <span style={{ color: "#d32f2f" }}><strong>{Translate('Major')} </strong></span>
        </>;
      case 2:
        return <>
          <span className="pi pi-exclamation-triangle" style={{ color: '#f57c00', paddingRight: "10px" }}></span>
          <span style={{ color: "#f57c00" }}><strong>{Translate('Moderate')} </strong></span>
        </>;
      case 3:
        return <>
          <span className="pi pi-exclamation-triangle" style={{ color: '#fbc02d', paddingRight: "10px" }}></span>
          <span style={{ color: "#fbc02d" }}><strong>{Translate('Minor')} </strong></span>
        </>;
      case 4:
        return <>
          <span className="pi pi-circle-on" style={{ color: '#b3b3b3', paddingRight: "10px" }}></span>
          <span style={{ color: "#b3b3b3" }}><strong>{Translate('Unknown')} </strong></span>
        </>
      default:
        return null;
    }
  }
  return null;
}

function getInteractionSeverityStatusLabel(id: number) {
  if (id != undefined) {
    switch (id) {
      case 1:
        return <span className="interaction-severity-label" style={{ borderColor: "#d32f2f", color: '#b71c1c' }}>{Translate('Major')}</span>;
      case 2:
        return <span className="interaction-severity-label" style={{ borderColor: "#f57c00", color: '#d04900' }}>{Translate('Moderate')}</span>;
      case 3:
        return <span className="interaction-severity-label" style={{ borderColor: "#fbc02d", color: '#8a6600' }}>{Translate('Minor')}</span>;
      case 4:
        return <span className="interaction-severity-label" style={{ borderColor: "#b3b3b3", color: "#606060" }}>{Translate('Unknown')}</span>;
      default:
        return null;
    }
  }
  return null;
}

export default getInteractionSeverity;

